import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AgendaMedicaFiltroDTO } from '../../dtos/agenda-medica-filtro-dto';
import { Filial } from '../../filial/filial';
import { FilialService } from '../../filial/filial.service';
import { Medico } from '../../medico/medico';
import { PlanoSaude } from '../../plano-saude/plano-saude';
import { PlanoSaudeService } from '../../plano-saude/plano-saude.service';
import { ProcedimentoConsulta } from '../../procedimento/procedimento-consulta/procedimento-consulta';
import { ProcedimentoConsultaService } from '../../procedimento/procedimento-consulta/procedimento-consulta.service';
import { ChaveValorNumberInterface } from '../../util/chave-valor-number-interface';
import { Horario } from '../../util/hora-atendimeno';
import { Util } from '../../util/util';
import { AgendaMedica } from '../agenda-medica';
import { AgendaMedicaService } from '../agenda-medica.service';

@Component({
  selector: 'app-agenda-medica-maintenance',
  templateUrl: './agenda-medica-maintenance.component.html',
  styleUrls: ['./agenda-medica-maintenance.component.css']
})
export class AgendaMedicaMaintenanceComponent implements OnInit {

  formularioAgendaMedica: FormGroup;

  listaDiasDaSemana: ChaveValorNumberInterface[] = Util.listaDiasDaSemana;

  listaHorarios: Horario[] = Util.listaHorasAtendimentos;

  listaFiliais: Filial[] = [];

  filtroAgendaMedica: AgendaMedicaFiltroDTO;

  medicoSelecionado: Medico | null;

  listaDeProcedimentoConsulta: ProcedimentoConsulta[] = [];

  listaDePlanosDeSaude: PlanoSaude[] = [];

  constructor(private agendaMedicaService: AgendaMedicaService,
    private filialService: FilialService,
    private procedimentoConsultaService: ProcedimentoConsultaService,
    private planoSaudeService: PlanoSaudeService,
    private router: Router,
    private formBuilder: FormBuilder) {

    this.filtroAgendaMedica = history.state.filtroAgendaMedica;

    if (this.filtroAgendaMedica && this.filtroAgendaMedica.medico) {
      this.medicoSelecionado = this.filtroAgendaMedica.medico;
    } else {
      this.medicoSelecionado = null;
    }

    this.formularioAgendaMedica = this.formBuilder.group({
      horaAtendimentoInicial: [null, [Validators.required]],
      horaAtendimentoFinal: [null, [Validators.required]],
      tempoAtd: [null, [Validators.required]],
      atdIdadeMinima: [null],
      atdIdadeMaxima: [null],
      atdPortadorNecessidade: [null],
      procedimentos: [null, [Validators.required]],
      planosDeSaude: [null, [Validators.required]],
      dataInicioAgenda: ['', [Validators.required]],
      pk: this.formBuilder.group({
        idFilial: [null, [Validators.required]],
        idMedico: [{ value: null, disabled: true }, [Validators.required]],
        diaSemana: [null, [Validators.required]],
      })
    });
  }

  ngOnInit() {

    this.listarFiliais();

    this.listarProcedimentosConsulta();

    this.listarPlanosDeSaude();

    this.configurarForm();
  }

  save() {

    let agendaMedica: AgendaMedica = Object.assign(new AgendaMedica(), this.formularioAgendaMedica.value);

    if (this.medicoSelecionado) {

      agendaMedica.pk.idMedico = this.medicoSelecionado.id;

    }

    this.agendaMedicaService
      .criarAgendaMedicaAgrupada(agendaMedica).subscribe(data => {
        // console.log(data)

        this.gotoList();

      }, error => {
        console.log(error);
      });
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/agendaMedica'], {
      state: {
        filtroAgendaMedica: history.state.filtroAgendaMedica,
      }
    });
  }

  get formControl() {
    return this.formularioAgendaMedica.controls;
  }

  listarFiliais() {

    if (this.medicoSelecionado) {

      this.filialService.listarFilialPorMedicoEEspecialidade(this.medicoSelecionado.id, this.medicoSelecionado.idEspecialidade)
        .subscribe(data => {

          // console.log(data)
          this.listaFiliais = data;

        }, error => {
          console.log(error);
        });
    }
  }

  listarProcedimentosConsulta() {

    if (this.medicoSelecionado) {
      this.procedimentoConsultaService
        .listarConsultasPorEspecialidadeComProjecao(this.medicoSelecionado.idEspecialidade)
        .subscribe(data => {

          this.listaDeProcedimentoConsulta = data;

        });
    }
  }

  listarPlanosDeSaude() {

    if (this.medicoSelecionado) {
      this.planoSaudeService
        .listarPlanoSaudePorMedicoComProjecao(this.medicoSelecionado.id)
        .subscribe(data => {

          this.listaDePlanosDeSaude = data;

        });
    }
  }

  configurarForm(): void {

    // Configurar Campo Medico
    if (this.medicoSelecionado && this.formularioAgendaMedica) {
      this.formularioAgendaMedica.controls.pk.get('idMedico')?.patchValue(this.medicoSelecionado.nome);
    }

  }

  get controlProcedimentos() {

    return this.formularioAgendaMedica.controls.procedimentos;

  }

  get controlPlanosDeSaude() {

    return this.formularioAgendaMedica.controls.planosDeSaude;

  }
}
